// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CbdkkTa6sHBGrgpjQ7O5hw\\=\\={width:60vw}nav>a{text-decoration:none;color:inherit}", "",{"version":3,"sources":["webpack://./src/js/components/Header/Menu/NavigationMenu.module.scss"],"names":[],"mappings":"AAAA,4BACI,UAAA,CAGJ,MACI,oBAAA,CACA,aAAA","sourcesContent":[".main-container {\n    width: 60vw;\n}\n\nnav > a {\n    text-decoration: none;\n    color: inherit;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-container": "CbdkkTa6sHBGrgpjQ7O5hw=="
};
export default ___CSS_LOADER_EXPORT___;
